import { z } from "zod";

// Card (cartão de I/O) sob um Device.

export const CardTypeSchema = z.enum(["DIGITAL", "ANALOG"]);
export type CardType = z.infer<typeof CardTypeSchema>;

// Mensagem + predicados da regra ANALOG⇒separator. Exportados p/ o catálogo do assistente
// reusar a MESMA regra ao estender o objeto com deviceId/cardId (fonte única — guardrail #5).
export const CARD_SEPARATOR_REFINE = {
  message: "Cartão analógico exige um separador.",
  path: ["separator"],
};
export const cardCreateHasSeparator = (c: {
  type?: CardType;
  separator?: string | null;
}): boolean => c.type !== "ANALOG" || !!c.separator;
export const cardUpdateSeparatorOk = (c: { type?: CardType; separator?: string | null }): boolean =>
  c.type !== "ANALOG" || c.separator !== null;

// Objeto base (sem refine) — reusado pelo catálogo via .extend(); o request schema o refina.
export const CreateCardObjectSchema = z.object({
  code: z.string().min(1).max(40),
  type: CardTypeSchema,
  separator: z.string().min(1).max(8).optional(),
  name: z.string().max(120).optional(),
});
export const CreateCardRequestSchema = CreateCardObjectSchema.refine(
  cardCreateHasSeparator,
  CARD_SEPARATOR_REFINE
);
export type CreateCardRequest = z.infer<typeof CreateCardRequestSchema>;

export const UpdateCardObjectSchema = z.object({
  code: z.string().min(1).max(40).optional(),
  type: CardTypeSchema.optional(),
  separator: z.string().min(1).max(8).nullable().optional(),
  name: z.string().max(120).nullable().optional(),
});
export const UpdateCardRequestSchema = UpdateCardObjectSchema.refine(
  cardUpdateSeparatorOk,
  CARD_SEPARATOR_REFINE
);
export type UpdateCardRequest = z.infer<typeof UpdateCardRequestSchema>;

export const CardSchema = z.object({
  id: z.string().uuid(),
  deviceId: z.string().uuid(),
  code: z.string(),
  type: CardTypeSchema,
  separator: z.string().nullable(),
  name: z.string().nullable(),
  sensorCount: z.number().int().optional(),
  createdAt: z.string().datetime(),
});
export type Card = z.infer<typeof CardSchema>;
